import { render, staticRenderFns } from "./sub-header.vue?vue&type=template&id=73ecb3ff"
import script from "./sub-header.vue?vue&type=script&lang=js"
export * from "./sub-header.vue?vue&type=script&lang=js"
import style0 from "./sub-header.vue?vue&type=style&index=0&id=73ecb3ff&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports